import {Button, Space, Table, Tag} from 'antd';
import '../../pages/customerDashboard/styles.scss';
import dayjs from "dayjs";
import {NOT_AVAILABLE, YYYY_MM_DD, YYYY_MM_DD_HH_MM} from "../../util/Constants";
import {NumericFormat} from "react-number-format";
import {toNumber} from "lodash";
import CommonFunction from "../../util/CommonFunction";
import {TransactionHistoryFilterDto} from "../../dto/TransactionHistoryFilterDto";
import transactionFetchService from "../../service/transactionFetchService";
import {CommonAxiosSuccessResponseDto} from "../../dto/CommonAxiosSuccessResponseDto";
import {TransactionHistoryWrapperDto} from "../../dto/TransactionHistoryWrapperDto";
import ErrorHandler from "../../util/ErrorHandler";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";

const TRANSACTION_TYPE_TRANSFER_MONEY = "TRANSFER_MONEY"
const TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY = "SCHEDULE_WITHDRAW_MONEY_SCHEDULED"
const TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP = "SCHEDULE_WITHDRAW_MONEY_SWP"
const TRANSACTION_TYPE_WITHDRAW_MONEY = "WITHDRAW_MONEY"
const TRANSACTION_TYPE_INVEST_MONEY = "INVEST_MONEY"
const TRANSACTION_TYPE_DIVIDEND = "DIVIDEND"

interface PropTypes {
    portfolioId: string
    cinNumber: string
    accountNumber: string
}

const RecentTransaction = ({portfolioId, cinNumber, accountNumber}: PropTypes) => {
    const [tableData, setTableData] = useState<TransactionHistoryWrapperDto[]>()
    const [isLoading, setLoading] = useState(false);
    const history = useHistory();


    const columns = [
        {
            title: 'Transaction',
            dataIndex: 'transactionTag',
            key: 'transactionTag',
            width: 120,
            fixed: 'left',
            sorter: (a: TransactionHistoryWrapperDto, b: TransactionHistoryWrapperDto) => {
                const dateA = a.submittedDate ? dayjs(a.submittedDate) : dayjs(0);
                const dateB = b.submittedDate ? dayjs(b.submittedDate) : dayjs(0);
                return dateA - dateB;
            },
            render: (text: any, record: {
                status: string;
                transactionTag: string;
                submittedDate: string
            }) => <>
                <div className="transaction_type_div">
                    {/*<div className="transaction_type_icon">*/}
                    <div className={
                        record.transactionTag === TRANSACTION_TYPE_INVEST_MONEY ? 'invest-transaction' :
                            record.transactionTag === TRANSACTION_TYPE_WITHDRAW_MONEY ? 'withdraw-transaction' :
                                record.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ? 'withdraw-transaction' :
                                    record.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ? 'withdraw-transaction' :
                                        record.transactionTag === TRANSACTION_TYPE_DIVIDEND ? 'dividend-transaction' :
                                            record.transactionTag === TRANSACTION_TYPE_TRANSFER_MONEY ? 'transfer-transaction' : 'switch-transaction'
                    }>
                        <div className={
                            record.status === 'PROCESSING' ? 'processing-transaction' :
                                record.status === 'SUBMITTED' ? 'submitted-transaction' :
                                    record.status === 'COMPLETED' ? 'completed-transaction' :
                                        record.status === 'DIVIDEND' ? 'dividend-transaction' :
                                            record.status === 'CANCELLED' ? 'cancelled-transaction' : 'rejected-transaction'
                        }>
                            <div className="transfer-icon"></div>

                        </div>
                    </div>
                    <div className="transaction_text">
                            <span className="transaction_type">
                                {
                                    record.transactionTag === 'INVEST_MONEY' ? 'Invest' :
                                        record.transactionTag === TRANSACTION_TYPE_TRANSFER_MONEY ? 'Transfer' :
                                            record.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY ? 'Scheduled Withdraw' :
                                                record.transactionTag === TRANSACTION_TYPE_SCHEDULE_WITHDRAW_MONEY_SWP ? 'Scheduled Withdraw SWP' :
                                                    record.transactionTag === TRANSACTION_TYPE_DIVIDEND ? 'Dividend' :
                                                        record.transactionTag === TRANSACTION_TYPE_WITHDRAW_MONEY ? 'Withdraw' : 'Switch'
                                }
                            </span>
                        <span className="transaction_date">on <span
                            className={'bold-date-time'}>
                            {null != text ? dayjs(record.submittedDate).format(YYYY_MM_DD) : NOT_AVAILABLE}
                        </span>
                        </span>
                    </div>
                </div>
            </>,
        },
        {
            title: 'Portfolio ID',
            dataIndex: 'portfolioId',
            key: 'portfolioId',
            width: 120,
            sorter: (a: any, b: any) => {
                a = a.portfolioId == null ? '' : a.portfolioId
                b = b.portfolioId == null ? '' : b.portfolioId
                return a.localeCompare(b);
            },
            render: (text: any, record: {
                portfolioId: string;
                portfolioType: string;

            }) => <>
                <div className="portfolio-details">
                    <div className="portfolio-id-data">
                        <span>{CommonFunction.validateText(record.portfolioId)}</span>
                    </div>
                    <div className="portfolio-type-tag">
                        {/*<Tag color='purple'>Joint Account</Tag>*/}
                        <Tag color='processing'>{CommonFunction.validateText(record.portfolioType)}</Tag>
                    </div>
                </div>
            </>
        },
        {
            title: 'Units',
            dataIndex: 'quantities',
            key: 'quantities',
            width: 80,
            sorter: (a: any, b: any) => (a.quantities - b.quantities),
            render: (text: any, record: any) =>
                <span>
                    {null != text ?
                        <NumericFormat value={text} displayType={'text'} decimalScale={2} fixedDecimalScale={true}
                                       thousandSeparator={true}/> : NOT_AVAILABLE}
                </span>,
        },
        {
            title: 'Price',
            dataIndex: 'unit_price',
            key: 'unit_price',
            align: 'right',
            width: 100,
            sorter: (a: any, b: any) => (a.unit_price - b.unit_price),
            render: (text: any, record: any) =>
                <span>
                    {null != text ?
                        <NumericFormat value={text} displayType={'text'} decimalScale={4} fixedDecimalScale={true}
                                       thousandSeparator={true}/> : NOT_AVAILABLE}
                </span>,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 100,
            align: 'right',
            sorter: (a: any, b: any) => (a.amount - b.amount),

            render: (text: number) => (
                <>
                    {null != text ?
                        <NumericFormat value={text} displayType={'text'} decimalScale={2} fixedDecimalScale={true}
                                       thousandSeparator={true}/> : NOT_AVAILABLE}

                </>
            ),
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            align: 'center',
            fixed: 'right',
            width: 120,
            sorter: (a: any, b: any) => {
                a = a.status == null ? '' : a.status
                b = b.status == null ? '' : b.status
                return a.localeCompare(b);
            },
            render: (text: any, record: { status: any; }) => (
                <>
                    {getStatusTag(record.status)}

                </>
            ),
        }

    ];
    const getStatusTag = (status: string) => {
        return <Tag
            className={status === "PROCESSING" ? 'tag-processing' : status === "COMPLETED" ?
                'tag-success' : status === "SUBMITTED" ? 'tag-submitted' : status === "CANCELLED" ? 'tag-cancelled' : 'tag-reject'}>{status}</Tag>

    }
    const onViewMore = (cinNumber: string) => {
        if("COMBINE VIEW" == accountNumber){
            history.push(`/workflow/customer/transaction-history/all-transactions?cinNumber=${cinNumber}&type=1`);

        }else {
            history.push(`/workflow/customer/transaction-history/all-transactions?portfolioId=${accountNumber}&cinNumber=${cinNumber}`);
        }
    }


    const onSearch = (filterCriterias: {
        transactionType: null | string; amount: number | null;
        portfolioId: string | null; status: string | null, submittedDate: any, cin: string
    }) => {
        if (null != cinNumber && "" != cinNumber) {
            setLoading(true)
            let amountWithoutCommaSeperators = filterCriterias.amount
            if (filterCriterias.amount) {
                amountWithoutCommaSeperators = toNumber(CommonFunction.removeThousandSeparators(filterCriterias.amount.toString()))
            }

            let submittedDateFrom = null
            let submittedDateTo = null
            if (filterCriterias.submittedDate) {
                submittedDateFrom = filterCriterias.submittedDate[0].format(YYYY_MM_DD)
                submittedDateTo = filterCriterias.submittedDate[1].format(YYYY_MM_DD)
            }

            const filter = {
                transactionType: filterCriterias.transactionType ?? null,
                amount: amountWithoutCommaSeperators ?? null,
                portfolioId: filterCriterias.portfolioId ?? null,
                statuses: filterCriterias.status ?? null,
                submittedDateFrom: submittedDateFrom,
                cin: filterCriterias.cin,
                submittedDateTo: submittedDateTo
            } as TransactionHistoryFilterDto
            transactionFetchService.getTransactionHistoryListForDashboard(filter).then(
                (res: CommonAxiosSuccessResponseDto<TransactionHistoryWrapperDto[]>) => {

                    setTableData(res.data.results);
                    setLoading(false)
                }).catch((res) => {
                setLoading(false)
                ErrorHandler.handleError(res)
            })
        }
    }

    useEffect(() => {
        setTableData([])
        handleSearch()
    }, [cinNumber, portfolioId])
    const handleSearch = () => {
        if (portfolioId != null) {
            let filterCrier = {
                status: null,
                amount: null,
                portfolioId: portfolioId && portfolioId !== "0" ? portfolioId : null,
                submittedDate: null,
                transactionType: null,
                cin: cinNumber
            }
            onSearch(filterCrier)
        } else {
            setTableData([])
        }

    }
    return (
        <>
            <Table dataSource={tableData} columns={columns} pagination={false} loading={isLoading} />
            <Space style={{float: 'right'}}>
                <Button size={'large'} type="link" block disabled={tableData?.length <= 0} onClick={() => onViewMore(cinNumber)}>
                    <span style={{fontSize: 13, color: ''}}>View More</span>
                </Button>
            </Space>
        </>
    );
};

export default RecentTransaction;